import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import { isActionAllowed } from '../../../../modules/contexts/Auth/RequireAuth';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { getAllTasksSisAf } from '../../../../services/gestaoSisAF/tasksSisAfService';
import subAbas from '../subabas';
import {
  headersEntregas,
  valoresExibidosOffCanvasContratos,
} from './auxliarEntregas';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';

const EntregasIndex: React.FC = () => {
  //PERMISSOES-MODULOS
  const papelUsuarioOptions = usePapelUsuario();
  const moduloUsuarioOptions = useModuloUsuario();
  // Obter o módulo
  const MODULO = Number(
    moduloUsuarioOptions.find((modulo) => modulo.label === 'Contratos')
      ?.value || '0',
  );

  // Verificar permissões para ações
  const canDownload = isActionAllowed(MODULO, 'read', papelUsuarioOptions);
  const canInsert = isActionAllowed(MODULO, 'create', papelUsuarioOptions);
  //PERMISSOES

  const navigate = useNavigate();

  //Dados do componente
  const [formFiltros, setFormFiltros] = useState({
    interfaceSisAf: 0,
    moduloSisAf: 0,
    tipoTask: 0,
    responsavel: 0,
    dataEntrada: '',
    dataFinalizacao: '',
    funcionalidade: '',
    descricao: '',
    complexidade: '',
    reaproveitamentoCodigo: '',
    statusDesenvolvimento: '',
    pontosFuncionalidade: 0,
    pontosDesenvolvidos: 0,
    observacoes: '',
    level: '',
  });

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [data, setData] = useState<any[]>([]);

  // Buscar dados
  const fetchData = async () => {
    try {
      const registros = await getAllTasksSisAf();
      setData(registros);
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);

  const tableData = [
    {
      id: 1,
      // statusContrato: 'Vigente',
      // componenteAf: 'Estratégico',
      // modalidadeAquisicao: 'Pregão com ARP',
      // numeroContrato: '5474/24',
      // vigencia: '01/12/2024',
      // denominacaoGenerica: 'Produto Farmacêutica',
      // fornecedor: 'Fornecedor A Ltda.',
      // valorTotal: 35000.0,
    },
  ];

  const offCanvasData = [
    {
      id: 1,
      detalhes: 'Mais informações sobre o contrato.',
    },
  ];

  const handleClickInserir = () => {
    navigate('ficha/dadosgerais');
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;

    if (name === 'level' || name === 'statusDesenvolvimento') {
      // Permitir somente números, '<', '>', ou uma combinação destes com números
      if (
        /^[0-9]*$/.test(value) ||
        value === '<' ||
        value === '>' ||
        /^[<>][0-9]+$/.test(value)
      ) {
        setFormFiltros((prev) => ({ ...prev, [name]: value }));
      }
    } else if (name === 'interfaceSisAf' || name === 'moduloSisAf') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        [name]: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      interfaceSisAf: 0,
      moduloSisAf: 0,
      tipoTask: 0,
      responsavel: 0,
      dataEntrada: '',
      dataFinalizacao: '',
      funcionalidade: '',
      descricao: '',
      complexidade: '',
      reaproveitamentoCodigo: '',
      statusDesenvolvimento: '',
      pontosFuncionalidade: 0,
      pontosDesenvolvidos: 0,
      observacoes: '',
      level: '',
    });
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />

      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="150px">
              <Input
                name="level"
                label="Level"
                value={formFiltros.level}
                id="level"
                onChange={handleChange}
                style={{ textAlign: 'right' }}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersEntregas}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidosOffCanvasContratos}
          tituloCanvas="CONTRATOS"
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          downloadDisabled={!canDownload}
          inserir
          inserirDisabled={!canInsert}
          onClickInserir={handleClickInserir}
        />
      </BarraInferiorBotoes>
    </>
  );
};

export default EntregasIndex;
